// extracted by mini-css-extract-plugin
export default {"spinner":"ticket-types-sms-table_spinner__K5cOT"};